export default __webpack_public_path__ + "static/media/tip.c87eeb17.png";